import script from "./AiSummaryView.vue?vue&type=script&setup=true&lang=js"
export * from "./AiSummaryView.vue?vue&type=script&setup=true&lang=js"

import "./AiSummaryView.vue?vue&type=style&index=0&id=c72e82e8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c72e82e8"]])

export default __exports__